<template>
  <v-container class="kahon p-0 m-0" fluid>
    <v-img
      class="mx-auto"
      :src="require('../assets/Kahon-logo-white.png')"
      width="400"
      contain
    />
    <v-row class="text-center" align="center" justify="center">
      <v-col cols="12" sm="12" lg="4" offset-lg="1">
        <div class="text-h4 text-md-h3 text-lg-start white--text mb-3 font-weight-black">
          We help you make<br />
          space for what<br />
          really matter.<br />
        </div>
      </v-col>
      <v-col cols="12" sm="8" md="5" lg="4">
        <p class="text-start white--text">
          Established in 2017, KAHON.PH is the first tech-enabled full service,
          end-to-end storage solutions company in the Philippines.
        </p>
        <p class="text-start white--text">
          Unlike traditional self-storage facilities, we seamlessly integrate
          technology with our storage and logistics expertise to create a more
          convenient, reliable, and personalized storage solution.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Landing4WeHelpYou",

  data: () => ({}),
};
</script>

<style scoped>
.display-2 {
  font-family: "Work Sans", sans-serif !important;
  font-display: swap;
}
</style>
